import { GridPanel } from './GridPanel.component';

export default { GridPanel };
